<section class="chart-manager-page">
  <h1 class="chart-manager-title">{{ title() }}</h1>
  <hd-chart-manager mode="page" (loadChartRequested)="onLoadChart($event)" (timelineRequested)="onTimeline($event)"></hd-chart-manager>
</section>
